module.exports = __webpack_public_path__ + "static/media/Fundraising.786cca38.jpg";